export enum Encoding {
    ascii = 'ascii',
    base32 = 'base32',
    base64 = 'base64',
    hex = 'hex',
}
